import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewEncapsulation } from '@angular/core';
import { GlobalsAction } from '../../state-management/globals/globals.action';
import { Store } from '@ngrx/store';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { filter } from 'rxjs/operators';
import { UsersEffects } from '@toro/common/shared/state-management/users/users.effects';
import { Observable } from 'rxjs';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { LoginWraperService } from '@toro/common/shared/services/login.wraper.service';
import { LiveStreamAction } from '@toro/common/shared/state-management/live-stream/live-stream.action';

@Component({
    selector: 'hub-live-section',
    templateUrl: './hub-live-section.component.html',
    styleUrls: ['./hub-live-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class HubLiveSectionComponent extends DisposableSafelly {

    public liveId: string;
    public liveStatus: number;
    public isActive: boolean = false;
    public isDettached: boolean = false;
    public auth$: Observable<UsersState>;
    public isLogged: boolean = null;
    public registerAppUrl = this.settingsService.getConfigurationKeyValue('rau');

    @Input('darkTheme') public darkTheme: boolean = true;

    @Input('opened') public set opened(opened) {
        this.isActive = !!opened;
    };

    public get isDarkTheme() {
        return this.darkTheme;
    }

    public get watchLabel() {
        return this.isActive ? 'Fechar' : 'Assistir agora';
    }

    public get liveChatUri(): string {
        return `https://www.youtube.com/live_chat?v=${this.liveId}&embed_domain=${this.settingsService.getConfigurationKeyValue('appDomain')}`;
    }

    constructor(
        private store: Store<any>,
        private settingsService: SettingsService,
        public authEffects: UsersEffects,
        private changeDetectorRef: ChangeDetectorRef,
        private loginWraper: LoginWraperService,
    ) {
        super();
        this.auth$ = this.store.select((s) => s.authentication);
        this.disposableSubscriptions.push(
            this.store
                .select(( globalStore ) => globalStore.globals.liveIsAttached )
                .subscribe( (isAttached) => {
                    this.isDettached = !isAttached;
                    this.changeDetectorRef.markForCheck();
                }),
        );

        this.disposableSubscriptions.push(
            this.store
                .select(( liveStore ) => liveStore.liveStream.live )
                .pipe(
                    filter((live) => !!live),
                )
                .subscribe( (live) => {
                    this.liveId = live.videoid;
                    this.liveStatus = live.status;
                    this.changeDetectorRef.markForCheck();
                }),
        );

        this.disposableSubscriptions.push(
            this.auth$
                .subscribe((data) => {
                    this.isLogged = data.currentUser ? true : false;
                }),
        );
        if (!this.isMobile()) {
            this.isActive = true;
        }
        this.getLiveData();
    }

    public dettachLive() {
        this.store.dispatch({type: GlobalsAction.dettachLiveVideo});
    }

    public reloadChat() {
        this.getLiveData();
    }

    public getLiveData() {
        this.store.dispatch({ type: LiveStreamAction.getLive });
    }

    public togglePanel() {        
        this.isActive = !this.isActive;
    }

    public login() {
        this.loginWraper.navigateToLogin({ afterLoginRedirectTo: '/investir' });
    }

    public goToRegister() {
        window.location.href = this.registerAppUrl;
    }

    public isMobile(): boolean {
        return window.innerWidth <= 768;
    }

    public ngOnDestroy() {
        this.disposableSubscriptions.forEach( (subscription) => subscription.unsubscribe());
    }
}